import { render } from "./permissionManage.vue?vue&type=template&id=29abd302&scoped=true"
import script from "./permissionManage.vue?vue&type=script&lang=js"
export * from "./permissionManage.vue?vue&type=script&lang=js"

import "./permissionManage.vue?vue&type=style&index=0&id=29abd302&scoped=true&lang=scss"

import exportComponent from "D:\\未知比特项目\\前端项目\\adminSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29abd302"]])

export default __exports__